import { html, render } from 'lit';
import { GGOBaseComponent } from '../components/ggo.base.component.js';
import { ModalComponent } from '../components/modal/modal.component.js';
import { Translate } from './translate.js';
import { Toast } from './toast.js';
export class Message {
    static createModal(modalTemplate) {
        // Remove all existing modals
        const modals = document.querySelectorAll('.ggo-modal');
        modals.forEach((modal) => modal.remove());
        const container = document.createElement('div');
        document.body.appendChild(container);
        const toto = render(modalTemplate, container);
        // Afficher la modal
        const modal = container.querySelector('ggo-modal');
        if (!modal) {
            throw new Error('You must specify a ggo-modal element in the template');
        }
        modal.isOpen = true;
        return modal;
    }
    static createModalOLD(options) {
        const modal = GGOBaseComponent.createElement('ggo-modal');
        const slot = GGOBaseComponent.createElement('div', undefined, { slot: 'content' }, options.content);
        if (options.form) {
            slot.appendChild(options.form);
        }
        modal.appendChild(slot);
        document.body.appendChild(modal);
        if (options.validate) {
            modal.addEventListener('modalSave', (e) => {
                if (options.validate)
                    options.validate(e);
                modal.close();
            });
        }
        if (options.cancel) {
            modal.addEventListener('modalCancel', () => {
                if (options.cancel)
                    options.cancel();
            });
        }
        return modal;
    }
    static alert(text, error) {
        let details = '';
        if (error?.message) {
            details = `<p>${error.message}</p>`;
        }
        else if (error?.message) {
            details = `<p>${error.error}</p>`;
        }
        const modal = this.createModal(html `<ggo-modal .showCancelBtn="${false}" title="${Translate.get('msg_alert')}" variant="${ModalComponent.ALERT}"
        >${text}${details}</ggo-modal
      >`);
        modal.open();
    }
    static success(text) {
        const modal = this.createModal(html `<ggo-modal .showCancelBtn="${false}" title="${Translate.get('msg_success')}" variant="${ModalComponent.SUCCESS}">${text}</ggo-modal>`);
        modal.open();
    }
    static toast(text, variant = ModalComponent.SUCCESS) {
        if (variant === ModalComponent.ALERT)
            Toast.error(text);
        else
            Toast.success(text);
    }
    static async confirm(text) {
        return new Promise((resolve) => {
            const modal = this.createModal(html `<ggo-modal
          @save=${() => resolve(true)}
          @cancel=${() => resolve(false)}
          .autoClose=${false}
          title="${Translate.get('msg_confirm')}"
          variant="${ModalComponent.SUCCESS}"
          style: "width: 50%"
          >${text}</ggo-modal
        >`);
            modal.open();
        });
    }
    static async input(text, value) {
        return new Promise((resolve, reject) => {
            const id = Math.random().toString(36).substring(7);
            const modal = this.createModal(html `<ggo-modal
          @save=${() => {
                const input = document.getElementById(`text-input-${id}`);
                resolve(input.value);
            }}
          @cancel=${() => {
                reject();
            }}
          .autoClose=${false}
          title="${Translate.get('msg_input')}"
          variant="${ModalComponent.SUCCESS}"
          ><div class="slds-form-element">
            <label class="slds-form-element__label" for="text-input-${id}">${text}</label>
            <div class="slds-form-element__control">
              <input
                type="text"
                id="text-input-${id}"
                placeholder="${value ?? ''}"
                value="${value ?? ''}"
                required=""
                class="slds-input"
                style="width: 100%"
              />
            </div>
          </div>
        </ggo-modal>`);
            modal.open();
        });
    }
}
